import api from "@/services/api";

export type BulkCustomerInput = {
  document: string;
  name?: string;
  phone?: string;
  email?: string;
};

export type BulkCustomerPreviewStatus = "new" | "exists" | "invalid";

export type BulkCustomerPreviewItem = {
  row: number;
  document: string;
  name?: string;
  phone?: string;
  email?: string;
  status: BulkCustomerPreviewStatus;
  reason?: string;
};

export type BulkCustomersPreviewResponse = {
  total: number;
  toCreate: number;
  existing: number;
  invalid: number;
  items: BulkCustomerPreviewItem[];
};

class PreviewBulkClients {
  execute = async (customers: BulkCustomerInput[]) => {
    const response = await api().post(`/customers/bulk/preview`, {
      customers,
    });
    return response.data as BulkCustomersPreviewResponse;
  };
}

export { PreviewBulkClients };
